import { Target, Clock, AlertCircle, CheckCircle2 } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const priorityColors = {
  low: "bg-green-100 text-green-800 border-green-200",
  medium: "bg-blue-100 text-blue-800 border-blue-200",
  high: "bg-orange-100 text-orange-800 border-orange-200",
  urgent: "bg-red-100 text-red-800 border-red-200"
};

export const statusColors = {
  todo: "bg-slate-100 text-slate-800 border-slate-200",
  in_progress: "bg-yellow-100 text-yellow-800 border-yellow-200",
  delayed: "bg-red-100 text-red-800 border-red-200",
  completed: "bg-emerald-100 text-emerald-800 border-emerald-200"
};

export const statusIcons = {
  todo: <Target className="h-4 w-4" />,
  in_progress: <Clock className="h-4 w-4" />,
  delayed: <AlertCircle className="h-4 w-4" />,
  completed: <CheckCircle2 className="h-4 w-4" />
};

export const getSiteName = (sites, siteId) => {
  const site = sites.find(s => s.id === siteId);
  return site ? site.name : "Unknown Site";
};

export const getStudyName = (studies, studyId) => {
  const study = studies.find(s => s.id === studyId);
  return study ? study.name : "Unknown Study";
};

export const getRecruitmentStatusColor = (actual, target) => {
  if (!target || target === 0) return 'bg-gray-100 text-gray-800';
  const percentage = (actual / target) * 100;
  if (percentage >= 90) return 'bg-green-100 text-green-800';
  if (percentage >= 70) return 'bg-yellow-100 text-yellow-800';
  if (percentage >= 50) return 'bg-orange-100 text-orange-800';
  return 'bg-red-100 text-red-800';
};

export const getBudgetStatusColor = (spent, approved) => {
  if (!approved || approved === 0) return 'bg-gray-100 text-gray-800';
  const percentage = (spent / approved) * 100;
  if (percentage >= 95) return 'bg-red-100 text-red-800';
  if (percentage >= 80) return 'bg-orange-100 text-orange-800';
  if (percentage >= 60) return 'bg-yellow-100 text-yellow-800';
  return 'bg-green-100 text-green-800';
};

export const calculatePercentage = (actual, target) => {
  if (!target || target === 0) return 0;
  return Math.round((actual / target) * 100);
};

export const getDaysRemaining = (endDate) => {
  if (!endDate) return null;
  const end = new Date(endDate);
  const today = new Date();
  const diff = Math.ceil((end - today) / (1000 * 60 * 60 * 24));
  return diff;
};

export const getTimelineColor = (daysLeft) => {
  if (daysLeft === null) return 'text-gray-600';
  if (daysLeft < 0) return 'text-red-600';
  if (daysLeft < 30) return 'text-orange-600';
  if (daysLeft < 90) return 'text-yellow-600';
  return 'text-green-600';
};

export const getPriorityColor = (priority) => {
  switch(priority) {
    case 'High': return 'bg-red-100 text-red-800';
    case 'Medium': return 'bg-yellow-100 text-yellow-800';
    case 'Low': return 'bg-green-100 text-green-800';
    default: return 'bg-gray-100 text-gray-800';
  }
};

// Small color lookup maps to avoid nested ternaries in JSX
export const taskPriorityBadgeClass = {
  high: 'bg-red-100 text-red-800',
  medium: 'bg-yellow-100 text-yellow-800',
  low: 'bg-green-100 text-green-800',
};

export const taskStatusBadgeClass = {
  completed: 'bg-green-100 text-green-800',
  in_progress: 'bg-blue-100 text-blue-800',
  delayed: 'bg-red-100 text-red-800',
  todo: 'bg-gray-100 text-gray-800',
};

export const getTaskPriorityBadgeClass = (p) => taskPriorityBadgeClass[p] || 'bg-green-100 text-green-800';
export const getTaskStatusBadgeClass = (s) => taskStatusBadgeClass[s] || 'bg-gray-100 text-gray-800';

export const getConfidenceBadgeClass = (score) => {
  if (score >= 0.8) return 'bg-green-100 text-green-800';
  if (score >= 0.5) return 'bg-yellow-100 text-yellow-800';
  return 'bg-red-100 text-red-800';
};
